import Transform from '@ember-data/serializer/transform';

const identity = (x) => x;

export default class ArrayTransform extends Transform {
  deserialize(value, options = {}) {
    if (Array.isArray(value)) {
      const deserializeItem = options.deserializeItem || identity;
      value = (value ?? []).map((item) => deserializeItem(item));

      return value;
    } else {
      return [];
    }
  }

  serialize(value, options = {}) {
    if (Array.isArray(value)) {
      const serializeItem = options.serializeItem || identity;
      value = (value ?? []).map((item) => serializeItem(item));

      return value;
    } else {
      return [];
    }
  }
}
